/* Chubbytrend header interactions. Dawn remains responsible for core disclosure/search behavior. */
(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  const setMenuOpen = (menu, shouldOpen) => {
    const details = menu.querySelector(':scope > details');
    const summary = details?.querySelector(':scope > summary');
    if (!details || !summary) return;

    details.open = shouldOpen;
    summary.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  };

  const closeSiblingMenus = (menu) => {
    const nav = menu.closest('.ct-nav');
    nav?.querySelectorAll('header-menu').forEach((candidate) => {
      if (candidate !== menu) setMenuOpen(candidate, false);
    });
  };

  const initHeaderNavigation = (root = document) => {
    root.querySelectorAll('.ct-nav').forEach((nav) => {
      if (nav.dataset.ctNavigationReady === 'true') return;
      nav.dataset.ctNavigationReady = 'true';

      nav.querySelectorAll('header-menu').forEach((menu) => {
        const details = menu.querySelector(':scope > details');
        const summary = details?.querySelector(':scope > summary');
        if (!details || !summary) return;

        let closeTimer;
        const cancelClose = () => window.clearTimeout(closeTimer);
        const openMenu = () => {
          if (!desktopHover.matches) return;
          cancelClose();
          closeSiblingMenus(menu);
          setMenuOpen(menu, true);
        };
        const queueClose = () => {
          if (!desktopHover.matches) return;
          cancelClose();
          closeTimer = window.setTimeout(() => {
            if (!menu.contains(document.activeElement)) setMenuOpen(menu, false);
          }, 140);
        };

        menu.addEventListener('mouseenter', openMenu);
        menu.addEventListener('mouseleave', queueClose);
        menu.addEventListener('focusin', () => {
          cancelClose();
          closeSiblingMenus(menu);
        });
        menu.addEventListener('focusout', queueClose);

        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
          if (details.open) closeSiblingMenus(menu);
        });

        menu.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          setMenuOpen(menu, false);
          summary.focus();
        });
      });
    });
  };

  const closeAllMenus = () => {
    document.querySelectorAll('.ct-nav header-menu').forEach((menu) => setMenuOpen(menu, false));
  };

  document.addEventListener('DOMContentLoaded', () => initHeaderNavigation());
  document.addEventListener('shopify:section:load', (event) => initHeaderNavigation(event.target));
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.ct-nav')) closeAllMenus();
  });
})();
